// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vegan_toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 991px) {
  .vegan_toggle {
    padding: 10px;
  }
}
.vegan_toggle .filter-toggle {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 28px;
  margin-right: 10px;
  cursor: pointer;
}
.vegan_toggle .filter-toggle ion-icon {
  width: 20px;
  height: 20px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle ion-icon {
    width: 30px;
    height: 30px;
  }
}
.vegan_toggle .filter-toggle p {
  font-size: 14px;
  text-transform: capitalize;
  font-weight: bold;
  color: black;
  padding-left: 5px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle p {
    font-size: 18px;
  }
}
.vegan_toggle .toggler {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border: 0.7px solid black;
  box-shadow: inset -2px 2px 10px rgba(0, 0, 0, 0.25);
  padding: 1.5px 7px;
  border-radius: 50px;
  width: 164px;
  position: relative;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler {
    width: 233px;
    padding: 4px 15px;
  }
}
.vegan_toggle .toggler .toggler_item {
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 19px;
  color: #34A853;
  height: 20px;
  transition: all 0.4s;
  cursor: pointer;
  width: 33%;
  text-transform: capitalize;
  color: black;
}
.vegan_toggle .toggler .toggler_item ion-icon {
  width: 100%;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_item {
    padding: 0 4px;
    font-size: 14px;
  }
}
.vegan_toggle .toggler .toggler_item.selected {
  z-index: 10;
}
.vegan_toggle .toggler .toggler_pin {
  position: absolute;
  color: red;
  top: -3px;
  width: 29px;
  height: 30px;
  border: 1px solid black;
  border-radius: 50%;
  background: white;
  transition: all 0.3s ease-out;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin {
    top: -3px;
    width: 35px;
    height: 35px;
  }
}
.vegan_toggle .toggler .toggler_pin .pin_img {
  height: 40px;
  width: 40px;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin .pin_img {
    height: 50px;
    width: 50px;
  }
}
.vegan_toggle .toggler .toggler_pin.first {
  left: 3px;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin.first {
    left: 11px;
  }
}
.vegan_toggle .toggler .toggler_pin.second {
  left: 25px;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin.second {
    left: 42px;
  }
}
.vegan_toggle .toggler .toggler_pin.third {
  left: 44px;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin.third {
    left: 68px;
  }
}
.vegan_toggle .toggler .toggler_pin.fourth {
  left: 66px;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin.fourth {
    left: 97px;
  }
}
.vegan_toggle .toggler .toggler_pin.fifth {
  left: 87px;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin.fifth {
    left: 127px;
  }
}
.vegan_toggle .toggler .toggler_pin.sixth {
  left: 109px;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin.sixth {
    left: 156px;
  }
}
.vegan_toggle .toggler .toggler_pin.seventh {
  left: 131px;
}
@media (min-width: 991px) {
  .vegan_toggle .toggler .toggler_pin.seventh {
    left: 185px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-filters/menu-filters.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;ACHE;EDCF;IAKM,aAAA;EACJ;AACF;AACI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;AAER;ACpBE;EDgBI;IAII,WAAA;IACA,YAAA;EAIR;AACF;AAFM;EACE,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAIR;ACjCE;EDwBI;IAOI,eAAA;EAMR;AACF;AAHI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,iBAAA;EACA,yBAAA;EACA,mDAAA;EACA,kBAAA;EACA,mBAAA;EAEA,YAAA;EACA,kBAAA;AAGN;AClDE;EDmCE;IAeI,YAAA;IACA,iBAAA;EAIN;AACF;AAHM;EACE,YAAA;EAQA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;AAFR;AAjBQ;EACE,WAAA;AAmBV;AC3EE;EDqDI;IAMI,cAAA;IACA,eAAA;EAoBR;AACF;AANQ;EACE,WAAA;AAQV;AAFM;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EAOA,6BAAA;AAFR;AC/FE;EDkFI;IAUI,SAAA;IACA,WAAA;IACA,YAAA;EAOR;AACF;AAJQ;EACE,YAAA;EACA,WAAA;AAMV;AC1GE;EDkGM;IAII,YAAA;IACA,WAAA;EAQV;AACF;AALQ;EACE,SAAA;AAOV;ACnHE;ED2GM;IAGI,UAAA;EASV;AACF;AANQ;EACE,UAAA;AAQV;AC3HE;EDkHM;IAGI,UAAA;EAUV;AACF;AARQ;EACE,UAAA;AAUV;ACnIE;EDwHM;IAGI,UAAA;EAYV;AACF;AAVQ;EACE,UAAA;AAYV;AC3IE;ED8HM;IAGI,UAAA;EAcV;AACF;AAZQ;EACE,UAAA;AAcV;ACnJE;EDoIM;IAGI,WAAA;EAgBV;AACF;AAdQ;EACE,WAAA;AAgBV;AC3JE;ED0IM;IAGI,WAAA;EAkBV;AACF;AAhBQ;EACE,WAAA;AAkBV;ACnKE;EDgJM;IAGI,WAAA;EAoBV;AACF","sourcesContent":["@import \"../../../theme/mixins\";\n\n.vegan_toggle {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    @include desktop {\n      padding: 10px;\n    }\n\n    .filter-toggle {\n      display: flex;\n      align-items: center;\n      padding: 5px 10px;\n      border-radius: 28px;\n      margin-right: 10px;\n      cursor: pointer;\n      ion-icon {\n        width: 20px;\n        height: 20px;\n        @include desktop {\n          width: 30px;\n          height: 30px;\n        }\n      }\n      p {\n        font-size: 14px;\n        text-transform: capitalize;\n        font-weight: bold;\n        color: black;\n        padding-left: 5px;\n        @include desktop {\n          font-size: 18px;\n        }\n      }\n    }\n    .toggler {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    \n      background: white;\n      border: 0.7px solid black;\n      box-shadow: inset -2px 2px 10px rgba(0, 0, 0, 0.25);\n      padding: 1.5px 7px;\n      border-radius: 50px;\n      // width: 120px;\n      width: 164px;\n      position: relative;\n      @include desktop {\n        // width: 183px;\n        width: 233px;\n        padding: 4px 15px;\n      }\n      .toggler_item {\n        padding: 0px;\n        ion-icon {\n          width: 100%;\n        }\n        @include desktop {\n          padding: 0 4px;\n          font-size: 14px;\n        }\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-family: AppFontBold;\n        font-size: 12px;\n        line-height: 19px;\n        color: #34A853;\n        height: 20px;\n        transition: all 0.4s;\n        cursor: pointer;\n        width: 33%;\n        text-transform: capitalize;\n        color: black;\n        &.selected {\n          z-index: 10;\n\n          // color: transparent;\n        }\n      }\n    \n      .toggler_pin {\n        position: absolute;\n        color: red;\n        top: -3px;\n        width: 29px;\n        height: 30px;\n        border: 1px solid black;\n        border-radius: 50% ;\n        background: white;\n        @include desktop {\n          top: -3px;\n          width: 35px;\n          height: 35px;\n        }\n  \n        transition: all 0.3s ease-out;\n        .pin_img {\n          height: 40px;\n          width: 40px;\n          @include desktop {\n            height: 50px;\n            width: 50px;\n          }\n        }\n    \n        &.first {\n          left:3px;\n          @include desktop {\n            left: 11px;\n          }\n        }\n    \n        &.second {\n          left: 25px;\n          @include desktop {\n            left: 42px;\n          }\n        }\n        &.third {\n          left: 44px;\n          @include desktop {\n            left: 68px;\n          }\n        }\n        &.fourth {\n          left: 66px;\n          @include desktop {\n            left: 97px;\n          }\n        }\n        &.fifth {\n          left: 87px;\n          @include desktop {\n            left: 127px;\n          }\n        }\n        &.sixth {\n          left: 109px;\n          @include desktop {\n            left: 156px;\n          }\n        }\n        &.seventh {\n          left: 131px;\n          @include desktop {\n            left: 185px;\n          }\n        }\n      }\n    }\n  }","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
